import {
  CAlert,
  CButton,
  CCol,
  CContainer,
  CForm,
  CFormGroup,
  CInput,
  CLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CSelect,
  CSpinner,
  CSwitch,
  CTextarea,
} from '@coreui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import AuthManager from '../../utils/AuthManager'
import Backend from '../../utils/Backend'
import Notify from '../../utils/Notify'
import CustomDatePicker from '../components/CustomDatePicker'
import { accountTypes } from '../../constants/Options'

export default function ReceiptModal(props) {
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [accountHeads, setAccountHeads] = useState(props.accountHeads)
  const [receipt, setReceipt] = useState({
    id: '',
    type: 'Cash',
    account_type:
      AuthManager.getCurrentUser().role !== 'admin'
        ? AuthManager.getCurrentUser().role.toUpperCase()
        : '',
    date: moment().format('YYYY-MM-DD'),
    receipt_no: '',
    bank_ref_no: '',
    contra_bank: '',
    from_contra_bank: '',
    to_contra_bank: '',
    particulars: '',
    purpose: '',
    account_head_id: '',
    amount: '',
    status: 'Received',
    note: '',
  })

  function handleFormChange(evt) {
    setError('')
    let name = evt.target.name
    let value = evt.target.value
    if (name == 'amount') {
      value = parseFloat(parseFloat(value).toFixed(2))
    }

    setReceipt({ ...receipt, [name]: value })
  }

  function validateData() {
    // if (!receipt.fiscal_account_id) {
    //   setError('Select Fiscal Account')
    //   return false;
    // } else if (!receipt.month) {
    //   setError('Select Month')
    //   monthRef.current.focus()
    //   return false;
    // } else if (!receipt.year) {
    //   setError('Select Year')
    //   return false;
    // } else if (isNaN(receipt.amount) || receipt.amount < 1) {
    //   setError('Receipt amount must be number and greater than Zero')
    //   return false;
    // } else if (isNaN(receipt.interest_rate) || receipt.interest_rate < 1) {
    //   setError('Interest rate must be number and greater than Zero')
    //   return false;
    // }

    // if (!General.validateContributionDate(receipt, fiscalAccount.financial_year)) {
    //   setError('Please select month and year between selected Fiscal Account(Financial Year)')
    //   return false
    // }

    setError('')
    return true
  }

  async function handleSubmit() {
    setLoading(true)

    if (!validateData()) {
      setLoading(false)
      return
    }

    try {
      if (!props.receipt) {
        const response = await Backend.addReceipt(receipt)
        Notify.success('Receipt added successfully.')
        props.onAdded()
      } else {
        const response = await Backend.updateReceipt(receipt.id, receipt)
        Notify.success('Receipt updated successfully.')
        props.onAdded()
      }
      setLoading(false)
    } catch (error) {
      setError(error.message)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (props.receipt) {
      setReceipt(props.receipt)
    }
  }, [])

  return (
    <>
      <CModal
        show={props.show}
        centered={true}
        size={'md'}
        onClose={() => props.onClose()}
      >
        <CModalHeader closeButton>
          <CModalTitle>{props.receipt ? 'Edit' : 'Add'} Receipt </CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CContainer fluid>
            <CRow>
              <CCol>
                <CForm
                  onSubmit={(e) => {
                    e.preventDefault()
                    handleSubmit()
                  }}
                >
                  <CFormGroup>
                    <CLabel>Type: </CLabel>
                    <br />
                    <CLabel className={'pl-0'}>Cash</CLabel>
                    <CSwitch
                      disabled={
                        props.receipt && props.receipt.type === 'Contra'
                      }
                      className="text-right ml-1"
                      checked={receipt.type == 'Cash'}
                      color="dark"
                      size="lg"
                      variant="3d"
                      shape="pill"
                      onChange={(e) => {
                        setError('')
                        setReceipt({ ...receipt, type: 'Cash', purpose: '' })
                      }}
                    />
                    <CLabel className={'pl-4'}>Bank</CLabel>
                    <CSwitch
                      disabled={
                        props.receipt && props.receipt.type === 'Contra'
                      }
                      className="text-right mt-2 ml-1"
                      checked={receipt.type == 'Bank'}
                      color="dark"
                      size="lg"
                      variant="3d"
                      shape="pill"
                      onChange={(e) => {
                        setError('')
                        setReceipt({
                          ...receipt,
                          type: 'Bank',
                          purpose: '',
                        })
                      }}
                    />
                    <CLabel className={'pl-4'}>Contra Entry</CLabel>
                    <CSwitch
                      disabled={
                        props.receipt && props.receipt.type !== 'Contra'
                      }
                      className="text-right mt-2 ml-1"
                      checked={receipt.type == 'Contra'}
                      color="dark"
                      size="lg"
                      variant="3d"
                      shape="pill"
                      onChange={(e) => {
                        setError('')
                        setReceipt({
                          ...receipt,
                          type: 'Contra',
                          purpose: 'Withdraw',
                        })
                      }}
                    />
                  </CFormGroup>

                  {receipt.type != 'Contra' && (
                    <>
                      <CFormGroup>
                        <CLabel>Receipt No</CLabel>
                        <CInput
                          value={receipt.receipt_no}
                          type="text"
                          name="receipt_no"
                          onChange={(e) => handleFormChange(e)}
                        />
                      </CFormGroup>
                      {receipt.type == 'Bank' && (
                        <CFormGroup>
                          <CLabel>Bank Reference No</CLabel>
                          <CInput
                            value={receipt.bank_ref_no}
                            type="text"
                            name="bank_ref_no"
                            onChange={(e) => handleFormChange(e)}
                          />
                        </CFormGroup>
                      )}
                      <CFormGroup>
                        <CLabel>Particulars</CLabel>
                        <CInput
                          value={receipt.particulars}
                          type="text"
                          name="particulars"
                          onChange={(e) => handleFormChange(e)}
                        />
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Purpose</CLabel>
                        <CInput
                          value={receipt.purpose}
                          type="text"
                          name="purpose"
                          onChange={(e) => handleFormChange(e)}
                        />
                      </CFormGroup>
                      <CFormGroup>
                        <CustomDatePicker
                          label={'Date'}
                          value={
                            props.receipt
                              ? props.receipt.date
                              : moment().format('YYYY-MM-DD')
                          }
                          onApply={(date) => {
                            setError('')
                            setReceipt({
                              ...receipt,
                              date: moment(date).format('YYYY-MM-DD'),
                            })
                          }}
                        />
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Account Head</CLabel>
                        <CSelect
                          value={receipt.account_head_id}
                          name="account_head_id"
                          onChange={(e) => {
                            handleFormChange(e)
                          }}
                        >
                          <option value="">Select Account Head</option>
                          {accountHeads.map((accountHead) => {
                            if (accountHead.type == 'Receipt') {
                              return (
                                <option value={accountHead.id}>
                                  {accountHead.name}
                                </option>
                              )
                            }
                          })}
                        </CSelect>
                      </CFormGroup>
                      <CFormGroup
                        style={{
                          display:
                            AuthManager.getCurrentUser().role == 'admin'
                              ? 'block'
                              : 'none',
                        }}
                      >
                        <CLabel>Account Type</CLabel>
                        <CSelect
                          value={receipt.account_type}
                          name="account_type"
                          onChange={(e) => {
                            handleFormChange(e)
                          }}
                        >
                          <option value="">Select Account Type</option>
                          {accountTypes.map((accountType) => {
                            return (
                              <option value={accountType.value.toUpperCase()}>
                                {accountType.label}
                              </option>
                            )
                          })}
                        </CSelect>
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Amount</CLabel>
                        <CInput
                          value={receipt.amount}
                          type="number"
                          name="amount"
                          onChange={(e) => handleFormChange(e)}
                        />
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Notes</CLabel>
                        <CTextarea
                          name={'note'}
                          onChange={(e) => handleFormChange(e)}
                        >
                          {receipt.note}
                        </CTextarea>
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Status: </CLabel>
                        <CSwitch
                          className="text-right ml-5"
                          checked={receipt.status == 'Received'}
                          color="dark"
                          size="lg"
                          variant="3d"
                          shape="pill"
                          onChange={(e) => {
                            setReceipt({ ...receipt, status: 'Received' })
                          }}
                        />
                        <CLabel className={'pl-2'}>Received</CLabel>
                        <CSwitch
                          className="text-right mt-2 ml-5"
                          checked={receipt.status == 'Pending'}
                          color="dark"
                          size="lg"
                          variant="3d"
                          shape="pill"
                          onChange={(e) => {
                            setReceipt({ ...receipt, status: 'Pending' })
                          }}
                        />
                        <CLabel className={'pl-2'}>Pending</CLabel>
                      </CFormGroup>
                    </>
                  )}

                  {receipt.type == 'Contra' && (
                    <>
                      <CAlert color={'info'}>
                        Hemi entry i siam rual hian payment lamah contra entry a
                        in siam ve nghal a, chuvangin payment lamah contra turin
                        enter nawn a ngai lo.
                      </CAlert>
                      <CFormGroup>
                        <CLabel>Purpose: </CLabel>
                        <br />
                        <CLabel className={'pl-0'}>Withdraw</CLabel>
                        <CSwitch
                          className="text-right ml-1"
                          checked={receipt.purpose == 'Withdraw'}
                          color="dark"
                          size="lg"
                          variant="3d"
                          shape="pill"
                          onChange={(e) => {
                            setReceipt({ ...receipt, purpose: 'Withdraw' })
                          }}
                        />
                        <CLabel className={'pl-3'}>Deposit</CLabel>
                        <CSwitch
                          className="text-right mt-2 ml-1"
                          checked={receipt.purpose == 'Deposit'}
                          color="dark"
                          size="lg"
                          variant="3d"
                          shape="pill"
                          onChange={(e) => {
                            setReceipt({ ...receipt, purpose: 'Deposit' })
                          }}
                        />
                        <CLabel className={'pl-3'}>Bank Transfer</CLabel>
                        <CSwitch
                          className="text-right mt-2 ml-1"
                          checked={receipt.purpose == 'Bank Transfer'}
                          color="dark"
                          size="lg"
                          variant="3d"
                          shape="pill"
                          onChange={(e) => {
                            setReceipt({
                              ...receipt,
                              purpose: 'Bank Transfer',
                            })
                          }}
                        />
                      </CFormGroup>
                      {receipt.purpose === 'Bank Transfer' ? (
                        <>
                          <CFormGroup>
                            <CLabel>From Bank</CLabel>
                            <CInput
                              value={receipt.from_contra_bank}
                              type="text"
                              name="from_contra_bank"
                              onChange={(e) => handleFormChange(e)}
                            />
                          </CFormGroup>
                          <CFormGroup>
                            <CLabel>To Bank</CLabel>
                            <CInput
                              value={receipt.to_contra_bank}
                              type="text"
                              name="to_contra_bank"
                              onChange={(e) => handleFormChange(e)}
                            />
                          </CFormGroup>
                        </>
                      ) : (
                        <CFormGroup>
                          <CLabel>Bank</CLabel>
                          <CInput
                            value={receipt.contra_bank}
                            type="text"
                            name="contra_bank"
                            onChange={(e) => handleFormChange(e)}
                          />
                        </CFormGroup>
                      )}

                      <CFormGroup>
                        <CustomDatePicker
                          label={'Date'}
                          value={
                            props.receipt
                              ? moment(props.receipt.date).format('DD/MM/YYYY')
                              : moment().format('DD/MM/YYYY')
                          }
                          onApply={(date) => {
                            setError('')
                            setReceipt({
                              ...receipt,
                              date: moment(date).format('YYYY-MM-DD'),
                            })
                          }}
                        />
                      </CFormGroup>

                      <CFormGroup
                        style={{
                          display:
                            AuthManager.getCurrentUser().role == 'admin'
                              ? 'block'
                              : 'none',
                        }}
                      >
                        <CLabel>Account Type</CLabel>
                        <CSelect
                          value={receipt.account_type}
                          name="account_type"
                          onChange={(e) => {
                            handleFormChange(e)
                          }}
                        >
                          <option value="">Select Account Type</option>
                          {accountTypes.map((accountType) => {
                            return (
                              <option value={accountType.value}>
                                {accountType.label}
                              </option>
                            )
                          })}
                        </CSelect>
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Amount</CLabel>
                        <CInput
                          value={receipt.amount}
                          type="number"
                          name="amount"
                          onChange={(e) => handleFormChange(e)}
                        />
                      </CFormGroup>
                    </>
                  )}
                </CForm>
                {error && <CAlert color={'danger'}>{error}</CAlert>}
              </CCol>
            </CRow>
          </CContainer>
        </CModalBody>
        <CModalFooter>
          <CButton
            variant="outline"
            color="danger"
            className="btn-sm pl-4 pr-4"
            disabled={loading}
            onClick={() => props.onClose()}
          >
            Close
          </CButton>
          <CButton
            color="dark"
            className="btn-sm pl-4 pr-4"
            disabled={loading}
            onClick={(e) => {
              e.preventDefault()
              handleSubmit()
            }}
          >
            {loading ? (
              <>
                <CSpinner component="span" size="sm" aria-hidden="true" />{' '}
                Saving...
              </>
            ) : (
              'Save Receipt'
            )}
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}
